import React from "react";
import "../screens/lng/lng.css";

const APPS = [
  { id: "netiv", label: "NETIV", url: import.meta.env.VITE_SUITE_NETIV_URL ?? "/" },
  { id: "fr8lens", label: "Fr8lens", url: import.meta.env.VITE_SUITE_FR8LENS_URL ?? "https://github.com/eiegit/LNG-FR8LENS" },
  { id: "emet", label: "EMET", url: import.meta.env.VITE_SUITE_EMET_URL ?? "https://github.com/eiegit/LNG-EMET" },
];

export function SuiteSwitcher({ decisionPackageId }: { decisionPackageId?: string }) {
  const linkedUrl = (url: string) => decisionPackageId
    ? `${url.replace(/\/$/, "")}/cases/${encodeURIComponent(decisionPackageId)}`
    : url;
  return (
    <label className="lng-suite-switcher">
      <span>NETIV Commercial Suite</span>
      <select aria-label="Open connected application" value="netiv" onChange={(event) => {
        const app = APPS.find((item) => item.id === event.target.value);
        if (app && app.id !== "netiv") window.location.assign(linkedUrl(app.url));
      }}>
        {APPS.map((app) => <option key={app.id} value={app.id}>{app.label}</option>)}
      </select>
    </label>
  );
}
